module.exports = __webpack_public_path__ + "img/cole-keister-1407447-unsplash.551a559f.jpg";